"use client";
import React from "react";
import { PageLayout } from "@/components/layout/PageLayout";
import { HeroSection } from "@/components/sections/HeroSection";
import { AboutSection } from "@/components/sections/AboutSection";
import { WorkProcessSection } from "@/components/sections/WorkProcessSection";
import { LatestServiceSection } from "@/components/sections/LatestServiceSection";
import { GallerySection } from "@/components/sections/GallerySection";
import { DigitalSolutionsSection } from "@/components/sections/DigitalSolutionsSection";
import { ClientsReviewsSection } from "@/components/sections/ClientsReviewsSection";
import { AskQuestionSection } from "@/components/sections/AskQuestionSection";
import { BrandsSliderSection } from "@/components/sections/BrandsSliderSection";
import { ContactUsSection } from "@/components/sections/ContactUsSection";

const HomePage = (): React.JSX.Element => {
  return (
    <PageLayout>
      {/* Hero Section */}
      <HeroSection />

      {/* About Us Section */}
      <AboutSection />

      {/* Latest Services Section */}
      <LatestServiceSection />

      {/* Work Process Section */}
      <WorkProcessSection />

      {/* Gallery Section */}
      <GallerySection />

      {/* Digital Solutions Section */}
      <DigitalSolutionsSection />


      {/* Clients Reviews Section */} 
      <ClientsReviewsSection />

      {/* Ask Question Section */}
      <AskQuestionSection />

      <BrandsSliderSection />

      {/* Blog Section */}
      {/* <BlogSection /> */}

      {/* Contact Us Section */}
      <ContactUsSection />
    </PageLayout>
  );
};

export default HomePage;
